<template>
  <span
    v-if="messageResult && messageResult.newOrOldCompany"
    class="message"
  >
    <df-nav-item
      :href="messageResult.pcUrl"
      :prefix-icon="messageResult.messageCount > 0 ? bell_spots : bell"
    >
      {{ TLang('消息','common') }}
      <i
        v-if="messageResult.messageCount > 0"
        class="informationDot"
      ></i>
    </df-nav-item>
  </span>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      messageResult: null,
      bell: require('../imgs/bellNew.png'),
      // bell_spots: require('../imgs/bell_spots.png'),
      bell_spots: require('../imgs/bellNew.png'),
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    getMessage() {
      // this.apis.headerApi.getLogo().then(res => {
      //   this.messageResult = res;
      // });
      this.apis.newBfdHeaderApi.getMessage().then(res => {
        this.messageResult = res.data;
      });
    },
  },
};
</script>

<style scoped>
.message{
  position: relative;
  padding-left: 5px;
}
.message .informationDot {
  background: #ff4949;
  border: 1px solid #fff;
  border-radius: 50%;
  display: block;
  height: 4px;
  left: 0px;
  position: absolute;
  top: 0;
  width: 4px;
  box-sizing: border-box;
}
</style>
